import moment from 'moment-timezone';

export const getStartAndEndDateFromWeekId = ({ weekId }: { weekId: number }) => {
  const year = weekId.toString().slice(0, 4);
  const week = weekId.toString().slice(4);

  // Get UTC date for the start of the week
  // Note: Any change to this code will need to be tested across multiple timezones ( +UTC / -UTC and getNextWeekId, getPreviousWeekId methods)
  const startDate = moment()
    .utc()
    .isoWeekYear(parseInt(year))
    .isoWeek(parseInt(week))
    .startOf('isoWeek')
    .subtract(1, 'day');
  const endDate = moment(startDate.clone().add(7, 'days').valueOf() - 1);

  return {
    startDate: startDate.toDate(),
    endDate: endDate.toDate(),
  };
};

export const getPreviousWeekId = (weekId = getWeekId(new Date()), weeksToSubtract = 1) => {
  const { startDate } = getStartAndEndDateFromWeekId({ weekId });
  return getWeekId(
    moment
      .utc(startDate)
      .add(-7 * weeksToSubtract, 'd')
      .toDate(),
  );
};

export const getNextWeekId = (weekId = getWeekId(new Date()), weeksToAdd = 1) => {
  const { startDate } = getStartAndEndDateFromWeekId({ weekId });
  return getWeekId(
    moment
      .utc(startDate)
      .add(7 * weeksToAdd, 'd')
      .toDate(),
  );
};

/*
 * Gets the week id for date `d`
 */
export const getWeekId = (date?: Date | string | number) => {
  let instance;
  if (typeof date === 'string' && date.length) {
    instance = new Date(date);
  } else if (typeof date === 'number') {
    instance = new Date(date);
  } else if (date instanceof Date) {
    instance = date;
  } else {
    instance = new Date();
  }
  // Create a copy of this date object
  const target = new Date(instance.valueOf());

  // ISO week date weeks start on monday
  // so correct the day number
  // ** commented out as we have Sunday as Start of week day
  // const dayNr = (instance.getUTCDay() + 6) % 7; //
  const dayNr = instance.getUTCDay(); // Assumes Sunday as Start Of week

  // ISO 8601 states that week 1 is the week
  // with the first thursday of that year.
  // Set the target date to the thursday in the target week
  target.setUTCDate(target.getUTCDate() - dayNr + 3);

  // Store the millisecond value of the target date
  const firstThursday = target.valueOf();

  // Set the target to the first thursday of the year
  // First set the target to january first
  target.setUTCMonth(0, 1);
  // Not a thursday? Correct the date to the next thursday
  if (target.getUTCDay() !== 4) {
    target.setUTCMonth(0, 1 + ((4 - target.getUTCDay() + 7) % 7));
  }

  // The weeknumber is the number of weeks between the
  // first thursday of the year and the thursday in the target week
  const weekNumber = 1 + Math.ceil((firstThursday - target.valueOf()) / 604800000);
  return target.getUTCFullYear() * 100 + weekNumber;
};
